import WalletManagement from "./wallet-management.page";

export default WalletManagement;
